import Vue from 'vue'
import VueRouter from 'vue-router'
import autoRouter from "./pages/auto"
// import { getUser } from "@/util/auth";

Vue.use(VueRouter)

const routes = [
  // 这个是自动路由
  ...autoRouter,
  {
    path: "/",
    component: () => import("@/components/Foot"),
    children: [
      {
        path: "/",
        name: "home",
        component: () => import("@/views/home"),
        meta: {
          keepAlive: true // 需要被缓存
        }
      },
      {
        path: "/classify",
        name: "classify",
        component: () => import("@/views/classify"),
      },
      {
        path: "/car",
        name: "car",
        component: () => import("@/views/car"),
      },
      {
        path: "/my",
        name: "my",
        component: () => import("@/views/my"),
      },
      {
        path: "/my/invite/:invitedFrom/:invitedMode",
        name: "invite",
        component: () => import("@/views/my/invite"),
      }
    ]
  },
  {
    path: "/classify/commodity/details/:id/:status",
    name: 'details_status',
    component: () => import("@/views/classify/commodity/details"),
  }
]
// console.log(routes, "routes");
const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

// // 不需要检查登录的路径
// const noCheckPath = [
//   "/login/**",
//   "/comm/**"
// ]

// router.beforeEach((to, from, next) => {
//   const userInfo = getUser()

//   for (let i = 0; i < noCheckPath.length; i++) {
//     let pass =
//       noCheckPath[i] === to.path ||
//       (noCheckPath[i].endsWith("/**") &&
//         to.path.startsWith(noCheckPath[i].substring(0, noCheckPath[i].lastIndexOf('/'))));

//     if (pass) {
//       next();
//       return;
//     }
//   }

//   if (!userInfo) {
//     next({
//       name: 'login'
//     })
//   } else {
//     next()
//   }

// });

export default router
